'use client';

import React from 'react';
import EfWebNavList from './comps/EfWebNavList';
import SubClientList from './comps/SubClientList';

interface Props {
    prefixCls: string;
    navItems: any[];
    TextHeader: any;
    // 搜索面板
    SearchPanel?: any;
}

const DROPDOWN_CARD_TYPES = [1, 2, 3, 5, 6];

const NavList2: React.FC<Props> = ({ prefixCls, navItems, SearchPanel }) => {
    return (
        <EfWebNavList prefixCls={prefixCls} SearchPanel={SearchPanel}>
            {navItems.map((item, idx) => {
                const hasDropdown = DROPDOWN_CARD_TYPES.includes(item?.type) && item?.subs?.length > 0;
                return (
                    <EfWebNavList.Item
                        prefixCls={prefixCls}
                        itemId={item.id}
                        href={hasDropdown ? undefined : item.url}
                        title={item.name}
                        key={item.id || idx}
                    >
                        {hasDropdown ? <SubClientList prefixCls={prefixCls} item={item} itemId={item.id} title={item.name} key={item.id || idx} /> : null}
                    </EfWebNavList.Item>
                );
            })}
        </EfWebNavList>
    );
};

export default NavList2;
